export const MUST_APPEAR_FIELDS = Object.freeze({
  CADENCE: 'COMPANY__CADENCE',
  SCENARIO: 'COMPANY__SCENARIO',
});
